/** A number box's text as a whole number: digits only, empty is 0. */
export function wholeNumber(text: string): number {
  const digits = text.replace(/\D/g, '');
  return digits === '' ? 0 : Number(digits);
}
